import { OutlinedInput, withStyles } from "@material-ui/core";

export const CssOutlinedInput = withStyles(theme => ({
  root: {
    borderRadius: "12.5px",
    borderWidth: 2,
    borderColor: "#E1E1E1",
    [theme.breakpoints.down('lg')]: {
      borderRadius: "10px",
      borderWidth: 1.5,
    },
    [theme.breakpoints.down('lg')]: {
      borderRadius: "8px",
      borderWidth: 1,
    },
    [theme.breakpoints.down('sm')]: {
      borderRadius: "8px",
    },
    // [theme.breakpoints.down('lg')]: {
    //   fontSize: "12px"
    // },
    // [theme.breakpoints.down('md')]: {
    //   fontSize: "10px"
    // },
    // "&:hover $notchedOutline": {
    //   borderColor: theme.palette.color12.default
    // },
    "&$focused $notchedOutline": {
      borderWidth: 2,
      borderColor: "#006276"
    },
    "&$error $notchedOutline": {
      borderWidth: 2,
      borderColor: "#FB0707",
      [theme.breakpoints.down('md')]: {
        borderWidth: 1,
      },
    }
  },
  error: {},
  input: {
    padding: 16,
    paddingRight: 0,
    fontSize: 16,
    backgroundColor: "#ffffff",
    [theme.breakpoints.down('lg')]: {
      padding: 12,
      fontSize: 13
    },
    [theme.breakpoints.down('md')]: {
      padding: 10,
      fontSize: 10
    },
    [theme.breakpoints.down('sm')]: {
      padding: 14,
      fontSize: 14
    },
    [theme.breakpoints.down('xs')]: {
      padding: 12,
      fontSize: 12
    },
  },
  focused: {},
  notchedOutline: {
    // borderColor: "#66788a4d"
  }
}))(OutlinedInput)
